import React from 'react';
import { Route, Switch } from 'react-router';
import LandingPage from './LandingPage';
import ArtistsPage from './ArtistsPage';
import ArtistPage from './ArtistPage';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import ToSPage from './ToSPage';
import AboutUsPage from './AboutUsPage';
import PlansPage from './PlansPage';
import ToolkitPage from './ToolkitPage';

import TheaterRegisterPage from './TheaterRegisterPage';
import ForgotPasswordPage from './ForgotPasswordPage';
import TheatersPage from './TheatersPage';
import ProductionsPage from './ProductionsPage';
import ProductionPage from './ProductionPage';
import NotFoundPage from './NotFoundPage';
import TheaterPage from './TheaterPage';
import FAQPage from './FAQPage';

const General = () => (
  <Switch>
    <Route exact path="/" component={LandingPage} />

    <Route exact path="/artists" component={ArtistsPage} />
    <Route exact path="/artists/:page" component={ArtistsPage} />
    <Route
      exact
      path="/artist/:artistSlug"
      component={ArtistPage}
    />

    <Route exact path="/productions" component={ProductionsPage} />
    <Route exact path="/productions/:page" component={ProductionsPage} />
    <Route
      exact
      path="/production/:productionSlug"
      component={ProductionPage}
    />

    <Route exact path="/theaters" component={TheatersPage} />
    <Route exact path="/theaters/:page" component={TheatersPage} />
    <Route
      exact
      path="/theater/:theaterSlug"
      component={TheaterPage}
    />

    <Route exact path="/login" component={LoginPage} />
    <Route exact path="/forgot-password" component={ForgotPasswordPage} />
    <Route exact path="/loginOrRegister" component={LoginPage} />
    <Route exact path="/register" component={RegisterPage} />
    <Route exact path="/theaterRegister" component={TheaterRegisterPage} />

    <Route exact path="/plans" component={PlansPage} />
    <Route exact path="/toolkit" component={ToolkitPage} />
    <Route exact path="/about" component={AboutUsPage} />
    <Route exact path="/tos" component={ToSPage} />
    <Route exact path="/faq" component={FAQPage} />
    <Route path="*" component={NotFoundPage} />

  </Switch>
);

export default General;



// WEBPACK FOOTER //
// ./src/containers/General/index.js